import { useMutation, useQueryClient } from "@tanstack/react-query";
import { chatPreferenceApi } from "api/chatPreferenceApi";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const useChatPreference = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: chatPreferenceApi,
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(["chat-threads"]);

      AlertNotification("success", "Chat preference updated");

      // refresh chat list or messages
      queryClient.invalidateQueries({
        queryKey: ["user-request-list"],
        exact: false,
      });

      options?.onSuccess?.(data, variables);
    },
    onError: (error) => {
      AlertNotification("error", error.message || "Preference update failed");
      options?.onError?.(error);
    },
  });
};
